import { formatCellValue, pnlColor } from "../../lib/format";
import { usePagedRows } from "../../lib/pagination";
import { CHART_INK } from "../../lib/palette";
import { Pagination } from "./Pagination";

interface DataTableProps {
	columns: string[];
	rows: Record<string, unknown>[];
	pageSize?: number;
}

function isNumericColumn(
	rows: Record<string, unknown>[],
	col: string,
): boolean {
	return rows.some((row) => typeof row[col] === "number");
}

export function DataTable({ columns, rows, pageSize }: DataTableProps) {
	const { pageRows, page, pageCount, setPage } = usePagedRows(rows, pageSize);

	if (rows.length === 0) {
		return (
			<div className="text-xs font-mono text-base-content/50 py-6 text-center">
				No rows for this selection.
			</div>
		);
	}

	return (
		<div>
			<div
				className="rounded"
				style={{ border: `1px solid ${CHART_INK.gridline}` }}
			>
				<table className="w-full text-xs font-mono">
					<thead className="bg-base-300">
						<tr>
							{columns.map((col) => (
								<th
									key={col}
									className={`px-3 py-2 text-left font-semibold text-base-content/70 whitespace-nowrap ${
										isNumericColumn(rows, col) ? "text-right" : ""
									}`}
								>
									{col}
								</th>
							))}
						</tr>
					</thead>
					<tbody>
						{pageRows.map((row, i) => (
							<tr
								key={i}
								className="border-t border-base-content/5 hover:bg-base-content/5 transition-colors"
							>
								{columns.map((col) => {
									const cell = formatCellValue(row[col]);
									const color = pnlColor(col, row[col]);
									return (
										<td
											key={col}
											title={cell.full ?? undefined}
											className={`px-3 py-1.5 whitespace-nowrap text-base-content/90 ${
												isNumericColumn(rows, col)
													? "text-right tabular-nums"
													: ""
											}`}
											style={color ? { color } : undefined}
										>
											{cell.display}
										</td>
									);
								})}
							</tr>
						))}
					</tbody>
				</table>
			</div>
			{pageSize && (
				<Pagination
					page={page}
					pageCount={pageCount}
					totalItems={rows.length}
					pageSize={pageSize}
					onPageChange={setPage}
				/>
			)}
		</div>
	);
}
